import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import MbCheckList from 'components/molecules/MbCheckList';
import Button from '@material-ui/core/Button';
import MbButton from 'components/atoms/MbButton';
import { useTranslation } from 'react-i18next';

const checkListStyles = makeStyles((theme) => ({
  contentWrap: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  resetButton: {
    fontSize: 15,
  },
}));

/**
 * 필터 체크리스트 및 전체 선택 | 초기화, 저장버튼 포함
 */
const FilterCheckList = ({
  list,
  parentValue = null,
  handleOnClickFilter,
  byTargeting = false,
  advrtsPrdtCode = null,
  advrtsTpCode = {},
  handleSaveClick,
  displayFilterList = false,
  ...rest
}) => {
  const classes = checkListStyles();
  const { t } = useTranslation();
  const theme = useTheme();

  const handleOnClick = (value) => {
    let checked = true;
    if (value === 'Y' || value === 'N') {
      if (value === 'N') checked = false;
    } else {
      if (typeof advrtsTpCode[value] !== 'undefined') {
        // 기존에 있던 값이면 빼기
        checked = false;
      }
    }
    handleOnClickFilter(parentValue, value, checked);
  };

  return (
    <>
      <div className={classes.contentWrap}>
        {(() => {
          const result = [];
          for (let item of list) {
            const { label, value } = item;
            if (value === '00') continue;
            // 페이지별 디스플레이 필터 리스트 셋팅값이 없거나 있으면 세팅된 값만 보여줌
            if (parentValue !== null) {
              if (
                displayFilterList === false ||
                (typeof displayFilterList[parentValue][value] !== 'undefined' &&
                  typeof displayFilterList[parentValue][value] === 'number')
              ) {
                result.push(
                  <MbCheckList
                    key={`${label}_${value}`}
                    label={label}
                    onClick={() => handleOnClick(value)}
                    checked={
                      advrtsPrdtCode === parentValue &&
                      typeof advrtsTpCode[value] !== 'undefined'
                    }
                    {...rest}
                  />
                );
              }
            } else {
              result.push(
                <MbCheckList
                  key={`${label}_${value}`}
                  label={label}
                  onClick={() => handleOnClick(value)}
                  checked={
                    advrtsPrdtCode === parentValue &&
                    typeof advrtsTpCode[value] !== 'undefined'
                  }
                  {...rest}
                />
              );
            }
          }
          return result;
        })()}
      </div>
      <div>
        <Button
          className={classes.resetButton}
          onClick={() => handleOnClick('Y')}
        >
          {t('전체선택')}
        </Button>
        <Button
          className={classes.resetButton}
          onClick={() => handleOnClick('N')}
        >
          {t('전체해제')}
        </Button>
        <MbButton
          style={{ float: 'right' }}
          color={theme.palette.primary.deep}
          clickEvent={handleSaveClick}
        >
          {t('확인')}
        </MbButton>
      </div>
    </>
  );
};

export default FilterCheckList;
